import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import logo from "./logo.png";
import CvDownloadDropdown from "../cvDownload/CvDownloadDropdown.jsx";

function Data() {
  const es_en = useSelector((state) => state.translation);
  const [isBinaryModalOpen, setIsBinaryModalOpen] = useState(false);
  const continuityBinary =
    "01000101 01101100 00100000 01101111 01110000 01100101 01110010 01100001 01100100 01101111 01110010 00100000 01100100 01100101 00100000 01100011 01101111 01101110 01110100 01101001 01101110 01110101 01101001 01100100 01100001 01100100 00100000 01101110 01101111 00100000 01110011 01101111 01101100 01101111 00100000 01100011 01101111 01101110 01100101 01100011 01110100 01100001 00100000 01101100 01100001 01110011 00100000 01110000 01100001 01110011 01101001 01101111 01101110 01100101 01110011 00101100 00100000 01110011 01101001 01101110 01101111 00100000 01110001 01110101 01100101 00100000 01100001 01100011 01110100 01110101 01100001 00100000 01100011 01101111 01101101 01101111 00100000 01110101 01101110 01100001 00100000 01100011 01101111 01101110 01100100 01101001 01100011 01101001 01101111 01101110 00100000 01101001 01101110 01100100 01101001 01110011 01110000 01100101 01101110 01110011 01100001 01100010 01101100 01100101 00101110 00100000 01000101 01101100 00100000 01100110 01110101 01110100 01100010 01101111 01101100 00101100 00100000 01101100 01100001 00100000 01110000 01110010 01101111 01100111 01110010 01100001 01101101 01100001 01100011 01101001 01101111 01101110 00100000 01111001 00100000 01101100 01100001 00100000 01101101 01110101 01110011 01101001 01100011 01100001 00100000 01110011 01101111 01101100 01101111 00100000 01110100 01101001 01100101 01101110 01100101 01101110 00100000 01110011 01100101 01101110 01110100 01101001 01100100 01101111 00101100 00100000 01110100 01110010 01100001 01110011 01100011 01100101 01101110 01100100 01100101 01101110 01100011 01101001 01100001 00100000 01111001 00100000 01100011 01101111 01101110 01110100 01101001 01101110 01110101 01101001 01100100 01100001 01100100 00100000 01110011 01101001 00100000 01100101 01110011 01100001 00100000 01100011 01101111 01101110 01110011 01110100 01100001 01101110 01110100 01100101 00100000 01110011 01110101 01110000 01100101 01110010 01101001 01101111 01110010 00100000 01100101 01110011 01110100 01100001 00100000 01110000 01110010 01100101 01110011 01100101 01101110 01110100 01100101 00101110 00100000 01010100 01101111 01100100 01101111 00100000 01101100 01101111 00100000 01100100 01100101 01101101 01100001 01110011 00100000 01110011 01100101 00100000 01101101 01100001 01101110 01110100 01101001 01100101 01101110 01100101 00100000 01100101 01101110 00100000 01110000 01101001 01100101 00100000 01110011 01101001 00100000 01111001 00100000 01110011 01101111 01101100 01101111 00100000 01110011 01101001 00100000 01100101 01111000 01101001 01110011 01110100 01100101 00100000 01110101 01101110 01100001 00100000 01100011 01101111 01101110 01100101 01111000 01101001 01101111 01101110 00100000 01100100 01101001 01110010 01100101 01100011 01110100 01100001 00100000 01100011 01101111 01101110 00100000 01100101 01110011 01100101 00100000 01001001 01101110 01100110 01101001 01101110 01101001 01110100 01101111 00101110 00100000 01000001 01110011 01101001 00100000 01110011 01100101 00100000 01100011 01101001 01100101 01110010 01110010 01100001 00100000 01100101 01101100 00100000 01100011 01101001 01110010 01100011 01110101 01101001 01110100 01101110 00101110";
  useEffect(() => {
    const { body, documentElement } = document;
    const previousBodyOverflow = body.style.overflow;
    const previousHtmlOverflow = documentElement.style.overflow;

    if (isBinaryModalOpen) {
      body.style.overflow = "hidden";
      documentElement.style.overflow = "hidden";
    }

    return () => {
      body.style.overflow = previousBodyOverflow;
      documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [isBinaryModalOpen]);

  return (
    <div className="home__data">
      <h1 className="home__title">
        Mario Vidal{" "}
        <img
          src={logo}
          alt="logo"
          width="70px"
          title="Mario Vidal Padrón"
          className="home__title-logo"
        />
      </h1>
      <div className="home__signal-row">
        <box-icon
          name="football"
          type="solid"
          color="var(--first-color)"
          size="sm"
        ></box-icon>
        <span> || </span>
        <box-icon name="laptop" color="var(--first-color)" size="sm"></box-icon>
        <span> || </span>
        <box-icon name="music" color="var(--first-color)" size="sm"></box-icon>
        <span> &amp;&amp; </span>
        <box-icon
          name="infinite"
          color="var(--first-color)"
          size="sm"
        ></box-icon>
        <button
          type="button"
          className="home__signal-trigger"
          onClick={() => setIsBinaryModalOpen(true)}
          aria-label="Open hidden message"
        >
          <i className="uil uil-arrow-right" style={{ color: "#98ca3f" }}></i>
        </button>
      </div>
      <h3 className="home__subtitle">Full Stack Developer</h3>
      <p className="home__description">
        {" "}
        {es_en
          ? "Hi! I'm Mario Vidal, a Full Stack Developer with over 8 years in technology and 4 years specializing in building high-availability web applications. My experience includes working at companies like IBM, where I led technical solutions for clients such as Orange, Banco Santander, and El Corte Inglés. I've worked with technologies like Angular, React, Node.js, and NestJS, and my background in business administration and economics allows me to approach each project with both a technical and strategic vision."
          : "¡Hola! Soy Mario Vidal, desarrollador Full Stack con más de 8 años en tecnología y 4 años de especialización en la construcción de aplicaciones web de alta disponibilidad. Mi trayectoria incluye el paso por compañías como IBM, donde lideré soluciones técnicas para clientes como Orange, Banco Santander y El Corte Inglés. He trabajado con tecnologías como Angular, React, Node.js y NestJS, y mi formación en administración de empresas y economía me permite abordar cada proyecto con una visión tanto técnica como estratégica."}
      </p>

      <div className="home__buttons">
        <a
          href="#contact"
          className="button button--flex button--active-static"
        >
          {es_en ? "Contact" : "Contacto"}
          <svg
            className="button__icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M14.2199 21.9352C13.0399 21.9352 11.3699 21.1052 10.0499 17.1352L9.32988 14.9752L7.16988 14.2552C3.20988 12.9352 2.37988 11.2652 2.37988 10.0852C2.37988 8.91525 3.20988 7.23525 7.16988 5.90525L15.6599 3.07525C17.7799 2.36525 19.5499 2.57525 20.6399 3.65525C21.7299 4.73525 21.9399 6.51525 21.2299 8.63525L18.3999 17.1252C17.0699 21.1052 15.3999 21.9352 14.2199 21.9352ZM7.63988 7.33525C4.85988 8.26525 3.86988 9.36525 3.86988 10.0852C3.86988 10.8052 4.85988 11.9052 7.63988 12.8252L10.1599 13.6652C10.3799 13.7352 10.5599 13.9152 10.6299 14.1352L11.4699 16.6552C12.3899 19.4352 13.4999 20.4252 14.2199 20.4252C14.9399 20.4252 16.0399 19.4352 16.9699 16.6552L19.7999 8.16525C20.3099 6.62525 20.2199 5.36525 19.5699 4.71525C18.9199 4.06525 17.6599 3.98525 16.1299 4.49525L7.63988 7.33525Z"
              fill="var(--container-color)"
            ></path>
            <path
              d="M10.11 14.7052C9.92005 14.7052 9.73005 14.6352 9.58005 14.4852C9.29005 14.1952 9.29005 13.7152 9.58005 13.4252L13.16 9.83518C13.45 9.54518 13.93 9.54518 14.22 9.83518C14.51 10.1252 14.51 10.6052 14.22 10.8952L10.64 14.4852C10.5 14.6352 10.3 14.7052 10.11 14.7052Z"
              fill="var(--container-color)"
            ></path>
          </svg>
        </a>
        <CvDownloadDropdown isEnglish={es_en} variant="primary" />
        <div className="home__social">
          <a
            href="https://www.linkedin.com/in/mario-vidal-8138651a1/"
            className="home__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <i className="uil uil-linkedin"></i>
          </a>
          <a
            href="https://github.com/Mjosuex85"
            className="home__social-icon"
            target="_blank"
            rel="noreferrer"
          >
            <i className="uil uil-github"></i>
          </a>
        </div>
      </div>

      {isBinaryModalOpen && (
        <div className="home__binary-modal" role="dialog" aria-modal="true">
          <div className="home__binary-modal-card">
            <button
              type="button"
              className="home__binary-modal-close"
              onClick={() => setIsBinaryModalOpen(false)}
              aria-label="Close modal"
            >
              x
            </button>
            <p className="home__binary-modal-text">{continuityBinary}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Data;
